module.exports = __webpack_public_path__ + "img/bgi.ed7ccb7a.png";